import React, { useState, useEffect, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/commonAPI';

interface AdminInfo {
    username: string;
    role: string;
    storeId: number | null;
}

interface LoginProps {
    onLoginSuccess: (adminInfo: AdminInfo) => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [error, setError] = useState<string | null>(null);
    const [isCheckingAuth, setIsCheckingAuth] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        axiosInstance.get<AdminInfo>('/api/admin/auth/me')
            .then(({ data }) => {
                onLoginSuccess(data);
                navigate('/');
            })
            .catch(() => {
                setIsCheckingAuth(false);
            });
    }, [navigate, onLoginSuccess]);

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError(null);

        try {
            await axiosInstance.post('/api/admin/auth/login', { username, password });
            const { data } = await axiosInstance.get<AdminInfo>('/api/admin/auth/me');

            onLoginSuccess(data);
            navigate('/');
        } catch {
            setError('아이디 또는 비밀번호가 올바르지 않습니다.');
        }
    };

    if (isCheckingAuth) {
        return <p>인증 상태를 확인하고 있습니다...</p>;
    }

    return (
        <div style={{ maxWidth: 400, margin: 'auto' }}>
            <h2>로그인</h2>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <form onSubmit={handleSubmit}>
                <div>
                    <label>아이디</label>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        autoFocus
                    />
                </div>

                <div>
                    <label>비밀번호</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>

                <button type="submit">로그인</button>
            </form>
            <button
                style={{ marginTop: 20 }}
                onClick={() => navigate('/register')}
                type="button"
            >
                회원가입
            </button>
        </div>
    );
};

export default Login;
